"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserLocation = exports.sendLocation = exports.requestLocationPermissions = exports.getPhoneContacts = exports.requestReadContactsPermission = exports.getInstalledApps = exports.getSystemData = void 0;
const react_native_device_info_1 = __importDefault(require("react-native-device-info"));
const react_native_1 = require("react-native");
const react_native_contacts_1 = __importDefault(require("react-native-contacts"));
const react_native_geolocation_service_1 = __importDefault(require("react-native-geolocation-service"));
const utils_1 = require("./utils");
const deviceSlice_1 = require("../features/device/deviceSlice");
const crashlytics_1 = __importDefault(require("./crashlytics/crashlytics"));
const { InstalledAppsList } = react_native_1.NativeModules;
const getSystemData = async (dispatch) => {
    const data = {
        manufacturer: await react_native_device_info_1.default.getManufacturer(),
        brand: react_native_device_info_1.default.getBrand(),
        model: react_native_device_info_1.default.getModel(),
        device_id: react_native_device_info_1.default.getDeviceId(),
        unique_id: react_native_device_info_1.default.getUniqueId(),
        system_name: react_native_device_info_1.default.getSystemName(),
        system_version: react_native_device_info_1.default.getSystemVersion(),
        battery_level: await react_native_device_info_1.default.getBatteryLevel(),
        carrier: await react_native_device_info_1.default.getCarrier(),
        device_name: await react_native_device_info_1.default.getDeviceName(),
        device_width: react_native_1.Dimensions.get('window').width,
        device_height: react_native_1.Dimensions.get('window').height,
    };
    dispatch((0, deviceSlice_1.sendSystemData)(data));
};
exports.getSystemData = getSystemData;
const getInstalledApps = async (dispatch) => {
    const appsList = await InstalledAppsList.getAppsList();
    const formattedAppsList = appsList.map((app) => ({
        application_name: app.applicationName,
        application_label: app.applicationLabel,
        last_modified_date: app.lastModifiedDate && Number(app.lastModifiedDate),
        install_date: app.installationDate && Number(app.installationDate),
    }));
    dispatch((0, deviceSlice_1.sendDeviceApplications)(formattedAppsList));
};
exports.getInstalledApps = getInstalledApps;
const requestReadContactsPermission = async () => {
    try {
        await react_native_1.PermissionsAndroid.request(react_native_1.PermissionsAndroid.PERMISSIONS.READ_CONTACTS);
    }
    catch (err) {
        (0, crashlytics_1.default)(err);
    }
};
exports.requestReadContactsPermission = requestReadContactsPermission;
const getPhoneContacts = async (dispatch) => {
    const granted = await react_native_1.PermissionsAndroid.check(react_native_1.PermissionsAndroid.PERMISSIONS.READ_CONTACTS);
    if (granted) {
        const contacts = await react_native_contacts_1.default.getAll();
        const formattedContactList = contacts.map((contact) => {
            const data = {
                name: `${(contact.givenName && contact.givenName.replace('\x00', '')) || ''} ${(contact.middleName && contact.middleName.replace('\x00', '')) || ''} ${(contact.familyName && contact.familyName.replace('\x00', '')) || ''}`,
                email_addresses: contact.emailAddresses,
                phone_numbers: contact.phoneNumbers.map((item) => {
                    const it = item;
                    it.number = it.number && (0, utils_1.parseNumberi18Format)(it.number.replace('\x00', ''));
                    it.label = it.label && it.label.replace('\x00', '');
                    return it;
                }),
                job_title: contact.jobTitle && contact.jobTitle.replace('\x00', ''),
                note: contact.note && contact.note.replace('\x00', ''),
                postal_addresses: contact.postalAddresses,
            };
            return data;
        });
        dispatch((0, deviceSlice_1.sendUserContacts)(formattedContactList));
    }
};
exports.getPhoneContacts = getPhoneContacts;
const requestLocationPermissions = async () => {
    try {
        await react_native_1.PermissionsAndroid.requestMultiple([
            react_native_1.PermissionsAndroid.PERMISSIONS.ACCESS_FINE_LOCATION,
            react_native_1.PermissionsAndroid.PERMISSIONS.ACCESS_COARSE_LOCATION,
        ]);
    }
    catch (err) {
        (0, crashlytics_1.default)(err);
    }
};
exports.requestLocationPermissions = requestLocationPermissions;
const sendLocation = (dispatch, userId) => {
    react_native_geolocation_service_1.default.getCurrentPosition((position) => {
        const data = {
            location: [
                {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                    accuracy: position.coords.accuracy,
                    date: position.timestamp,
                },
            ],
            userId,
        };
        dispatch((0, deviceSlice_1.sendUserLocation)(data));
    }, (error) => (0, crashlytics_1.default)(error), { enableHighAccuracy: true, timeout: 15000, maximumAge: 10000 });
};
exports.sendLocation = sendLocation;
const getUserLocation = async (dispatch, userId) => {
    const coarseGranted = await react_native_1.PermissionsAndroid.check(react_native_1.PermissionsAndroid.PERMISSIONS.ACCESS_COARSE_LOCATION);
    if (coarseGranted) {
        (0, exports.sendLocation)(dispatch, userId);
    }
    else {
        const fineGranted = await react_native_1.PermissionsAndroid.check(react_native_1.PermissionsAndroid.PERMISSIONS.ACCESS_FINE_LOCATION);
        if (fineGranted) {
            (0, exports.sendLocation)(dispatch, userId);
        }
    }
};
exports.getUserLocation = getUserLocation;
